import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { SECONDARY } from 'app/constants/button'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import ComposeMessageIcon from 'app/components/icons/ComposeMessageIcon'

import ContainedButton from './ContainedButton'

const ComposeMessageButton = ({
  onClick,
  accesses = [AccessType.NOTIFICATION_SEND, AccessType.ADMINISTRATION],
  isLoading,
}) => {
  const { formatMessage } = useIntl()

  return (
    <AccessControl accesses={accesses}>
      <ContainedButton
        id="open-compose"
        type="button"
        color={SECONDARY}
        onClick={onClick}
        isLoading={isLoading}
        disabled={isLoading}
        className="w-full md:w-fit"
      >
        <div className="flex">
          <ComposeMessageIcon />
          <span className="ml-3">
            {formatMessage({
              id: 'action.compose.message',
            })}
          </span>
        </div>
      </ContainedButton>
    </AccessControl>
  )
}

ComposeMessageButton.propTypes = {
  onClick: PropTypes.func,
  accesses: PropTypes.string,
  isLoading: PropTypes.bool,
}
export default ComposeMessageButton
